'use client';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { useNavigation } from '@/components/flow/hooks/useNavigation';
import { DATA_KEYS } from '@/consts/dataKeys';

import CheckOutNowButton from './components/checkOutNowButton';
import { ExpressCheckout } from './components/expressCheckout';

export function CheckoutButton({
  showFlashMessageOnCheckoutSuccess,
  navigateToCheckoutMethod,
}: {
  showFlashMessageOnCheckoutSuccess?: boolean;
  /**
   * This controls how navigation to checkout is handled.
   *   - searchParam: Navigates by updating a query param in the URL.
   *                  This is used for the old style of combined recommendations and checkout step.
   *   - flow: Navigates by using the useNavigation hook to go to the next step in the flow.
   */
  navigateToCheckoutMethod: 'searchParam' | 'flow';
}) {
  const { checkoutPaymentDetails } = useDataProvider(
    DATA_KEYS.productSelection,
  );

  const { onNext } = useNavigation();

  const handleNavigation = () => {
    if (navigateToCheckoutMethod === 'searchParam') {
      window.location.assign('?checkout=true');
    } else {
      onNext();
    }
  };

  return (
    <div className="cur-flex cur-flex-col cur-gap-2">
      {checkoutPaymentDetails.isCollectionRequired ||
      checkoutPaymentDetails.isPaymentRequired ? (
        <ExpressCheckout
          showFlashMessageOnCheckoutSuccess={showFlashMessageOnCheckoutSuccess}
          navigateToCheckout={handleNavigation}
        />
      ) : (
        <CheckOutNowButton navigateToCheckout={handleNavigation} />
      )}
    </div>
  );
}
